import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IRequestTypeAddPayload, IRequestTypeUpdatePayload } from './cerere-type.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CerereTypeService {

    private serviceName = 'CerereTypeService';

    private token!: string;
    private basePath = environment.interop.basePath;
    private httpOptions: any;
    private getRequestTypesUrl = this.basePath + environment.interop.deps.nomenclatoare.cerereType.list;
    private getRequestTypesDTUrl = this.basePath + environment.interop.deps.nomenclatoare.cerereType.listDT;
    private storeRequestTypeUrl = this.basePath + environment.interop.deps.nomenclatoare.cerereType.store;
    private updateRequestTypeUrl = this.basePath + environment.interop.deps.nomenclatoare.cerereType.update;
    private deleteRequestTypeUrl = this.basePath + environment.interop.deps.nomenclatoare.cerereType.delete;
    private getRequestTypesActiveUrl = this.basePath + environment.interop.deps.nomenclatoare.cerereType.listActive;
    private getRequestTypesPublicUrl = this.basePath + environment.interop.deps.nomenclatoare.cerereType.listPublic;
    private changeRequestTypeActiveUrl = this.basePath + environment.interop.deps.nomenclatoare.cerereType.active;
    private changeRequestTypePublicUrl = this.basePath + environment.interop.deps.nomenclatoare.cerereType.public;

    private clearCacheUrl = this.basePath + environment.interop.deps.nomenclatoare.cerereType.clearCache;

    constructor(private http: HttpClient) { }

    getRequestTypesDT() {
        return this.http.get(this.getRequestTypesDTUrl, this.httpOptions);
    }

    clearCache() {
        return this.http.get(this.clearCacheUrl, this.httpOptions);
    }

    addRequestType(data: IRequestTypeAddPayload) {
        return this.http.post(this.storeRequestTypeUrl, data, this.httpOptions);
    }

    updateRequestType(data: IRequestTypeUpdatePayload) {
        return this.http.put(this.updateRequestTypeUrl, data, this.httpOptions);
    }

    deleteRequestType(requestTypeId: number) {
        return this.http.delete(this.deleteRequestTypeUrl + requestTypeId);
    }

    getActiveRequestTypes() {
        return this.http.get(this.getRequestTypesActiveUrl, this.httpOptions);
    }

    getRecordsList() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getRequestTypesActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get request with service ' + this.serviceName, error);
                    return throwError(error);
                })
            );
    }

    getPublicRequestTypes() {
        return this.http.get(this.getRequestTypesPublicUrl, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeRequestTypeActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeRequestTypePublicUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${this.token}`
            })
        };
    }
}
